import { render, staticRenderFns } from "./ConsiderResultAF.vue?vue&type=template&id=04131a6b&"
import script from "./ConsiderResultAF.vue?vue&type=script&lang=js&"
export * from "./ConsiderResultAF.vue?vue&type=script&lang=js&"
import style0 from "./ConsiderResultAF.vue?vue&type=style&index=0&id=04131a6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports